import styled from 'styled-components';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { primitive } from 'styles/constants/primitives';
import { fadeIn } from 'utils/style/animations';

interface IBannerContainerProps {
  $topInset: number;
}

interface IAuthenticatedContainerProps {
  hasPromoMessage: boolean;
}

export const BannerContainer = styled.div<IBannerContainerProps>`
  padding: 0 1rem;
  overflow: hidden;
  position: relative;
  background-color: ${Styles.color.contrastBackground};
  animation: ${fadeIn} 0.4s forwards;
  font-family: ${Styles.fontFamily.base};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color: ${primitive.$white};
  margin-top: 0;
  ${Styles.desktop`
    margin-top: ${(p: IBannerContainerProps) => p.$topInset}px;
  `};
`;

export const UnauthenticatedContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  ${Styles.desktop`
    align-items: center;
  `}
`;

export const AuthenticatedContainer = styled.div<IAuthenticatedContainerProps>`
  padding-top: ${p => (p.hasPromoMessage ? '1.4rem' : '0.4rem')};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  ${Styles.desktop`
    padding-bottom: 1rem;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: 1fr;
  `}
`;

export const StyledLoyaltyRewardsLogo = styled(LoyaltyRewardsLogo)`
  width: 13rem;
  margin-top: 0.5rem;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  ${Styles.desktop`
    justify-content: space-between;
  `}
`;

export const DetailsButton = styled(ActionButton)`
  font-family: ${Styles.fontFamily.brand};
  max-height: 2rem;
  max-width: 8rem;
  text-transform: none;
  color: ${primitive.$white};
  border-color: ${primitive.$white};
  background-color: ${Styles.color.contrastBackground};
`;

export const WelcomeMessage = styled.div`
  font-size: 0.75rem;
  ${Styles.desktop`
    font-size: 1rem;
  `}
`;

export const StyledLoyaltyPointsIcon = styled(LoyaltyPointsIcon)`
  path {
    fill: ${Styles.color.success};
  }
  && {
    vertical-align: bottom;
  }

  ${Styles.mobileTiny`
    width: 2.375rem;
  `}
`;

export const PointsContainer = styled.div`
  grid-column: 1/2;

  span {
    font-size: 2.5rem;
    margin-left: 0.4rem;
    ${Styles.mobileTiny`
      font-size: 1.6rem;
    `}
  }
`;

export const AvailableCrownsCaption = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9rem;
  margin-left: 0.4rem;
  color: ${Styles.color.alert.info.background};
  ${Styles.mobileTiny`
    font-size: 0.79rem;
  `}
  ${Styles.desktop`
    text-align: left
  `}
`;

export const UserCrownPointsContainer = styled.div`
  display: flex;
  justify-content: start;
  ${Styles.mobileTiny`
    font-size: 0.8rem;
  `}
`;

export const DashboardButton = styled(ActionButton)`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1rem;
  color: ${Styles.color.contrastBackground};
  border-color: ${Styles.color.background};
  background-color: ${Styles.color.background};
  grid-column: 3/4;
  align-self: center;
  height: 2.2rem;
  padding: 0;

  ${Styles.desktop`
    grid-column: 12;
    height: 2.5rem;
    min-width: 4rem;
    max-width: 8rem;
    padding: 0;
    font-size: 1rem;
  `}
`;

export const CurrentProgress = styled.span<{ $progress: number }>`
  display: block;
  height: 0.125rem;
  width: ${p => `calc(${p.$progress}%)`};
  border-radius: 1.5625rem;
  background-color: ${Styles.color.alert.info.background};
`;

export const PointsProgress = styled.div`
  grid-row: 2;
  grid-column: 1/4;
  width: calc(100% - 2rem);
  align-self: center;
  position: relative;
  background-color: ${Styles.color.grey.six};
  border-radius: 1.5625rem;
  margin: 0 0 1rem 0.4rem;
  ${Styles.desktop`
    grid-column: 3/11;
    grid-row: 1;
    width: 100%;
    margin: 0;
  `}
`;

export const ProgressBar = styled.div`
  position: relative;
  div:first-of-type {
    margin-left: 0;
  }

  span:first-of-type {
    margin-left: 0;
  }
`;

export const TierDot = styled.div<{ completed: boolean; left?: number; value: string }>`
  height: 0.6875rem;
  width: 0.6875rem;
  position: absolute;
  background: ${p => (p.completed ? Styles.color.alert.info.background : Styles.color.grey.six)};
  border-radius: 1.5625rem;
  margin-top: -0.249rem;
  margin-left: ${p => `calc(${p.left || 0}%)`};

  ::before {
    content: "${p => p.value}";
    position: absolute;
    font-size: 0.9rem;
    font-weight: normal;
    top: 0.6rem;
    left: calc((-0.625rem /4)*${p => p.value.length || 0});

    ${Styles.mobileTiny`
      font-size: 0.8rem;
    `}
  }
`;
